'
<template>
  <div>
    <select v-model="locale" id="locale-selector" @change="saveInLocalStorage">
      <option v-for="lang in langSorted"
              :value="lang.code">
        {{lang.name}}<span v-if="lang.nativeName && lang.nativeName.length > 0"> - </span>{{lang.nativeName}}
      </option>
    </select>
  </div>
</template>

<style scoped>
  @media only screen and (max-width: 480px) {
    #locale-selector {
      width: 100%;
    }
  }
</style>

<script>
  import langs from './momentlangs'
  import moment from 'moment'

  export default {
    data () {
      return {
        locale: window.USER.locale,
        languages: langs
      }
    },
    computed: {
      langSorted () {
        return this.languages.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      }
    },
    methods: {
      saveInLocalStorage () {
        try {
          if (typeof (Storage) !== 'undefined') {
            window.localStorage.setItem('locale', this.locale)
          }
        } catch (e) {
          // localstorage probably not enabled
        }
      },
      setLocale (userLocale) {
        let lowerCaseLocale = userLocale.toLowerCase()
        const fullCallLongLocales = ['ar-dz', 'ar-kw', 'ar-ly', 'ar-ma', 'ar-sa', 'ar-tn', 'de-at', 'de-ch', 'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-nz', 'es-do', 'es-us', 'fr-ca', 'fr-ch', 'ms-my', 'nl-be', 'pt-br', 'sr-cyrl', 'zh-vn', 'zh-tw']
        if (fullCallLongLocales.indexOf(lowerCaseLocale) < 0) {
          // remove country-code in safari ex. -DK from da-DK
          this.locale = lowerCaseLocale.substring(0, 2)
        } else {
          this.locale = lowerCaseLocale
        }
        this.$emit('locale', lowerCaseLocale)
      }
    },
    watch: {
      locale (val) {
        this.$emit('locale', val)
        this.$i18n.locale = val
        moment.locale(val)
      }
    },
    beforeMount () {
      // check for users locale value in localStorage
      try {
        if (typeof (Storage) !== 'undefined') {
          if (window.localStorage.getItem('locale') !== null) {
            this.setLocale(window.localStorage.getItem('locale'))
          } else {
            try {
              let browserLocale = navigator.language || navigator.userLanguage
              this.setLocale(browserLocale)
            } catch (e) {
              // navigator.language probably not enabled
              this.setLocale('en')
            }
          }
        }
      } catch (e) {
        // localstorage probably not enabled
        this.setLocale('en')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SetLocale.vue?174d78a6